import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { switchMap, map, skip } from 'rxjs/operators';
import { ResetPasswordService } from '../../services/account/reset-password.service';
import { ResetPasswordModel } from '../../models/account/reset-password.model';
import { Observable } from 'rxjs';
import { HttpParameterCodec } from '@angular/common/http';
import { LoginService } from '../../services/account/login.service';

@Component({
    selector: 'reset-password',
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.css'],
    providers: [ResetPasswordService]
})

export class ResetPasswordComponent implements OnInit {
    model: ResetPasswordModel = { code: '', email: '', password: '', confirmPassword: '', excludeNormal: false, userId: '' };
    isConfirmed: boolean = false;
    userPassedId: string = "";
    passwordRule: string = "Password must be 6 characters and contain an uppercase character, lowercase character, a digit, and a non-alphanumeric character";
    constructor(private activatedRoute: ActivatedRoute, private resetPasswordService: ResetPasswordService,
        private loginService: LoginService) {
    }
    ngOnInit() {
        this.userPassedId = this.activatedRoute.snapshot.queryParamMap.get('userId');
        let code: string = this.activatedRoute.snapshot.queryParamMap.get('code');
        let fixedUserId: string = this.userPassedId.split("-").join("9999123");
        this.resetPasswordService.get(code).subscribe(response => {
            this.model = response;
            //this.loginService.GetIsExcluded(fixedUserId).subscribe((data) => {
            //    if (data)
            //        this.passwordRule = "Password must be a number of at least 4 digits";
            //});
        });
    }
    public buttonClick() {
        let that = this;
        this.model.userId = this.userPassedId;
        this.resetPasswordService.post(this.model).subscribe(
            response => {
                that.isConfirmed = true;
            });
    }
}